import React from "react";
import styled, { css } from "styled-components";

const ProductSpecStyles = styled.div`
  ${({ ...props }) => css`
    margin-top: 32px;
    h3 {
      margin-bottom: 32px;
    }

    li {
      display: flex;
      align-items: center;
      border-top: solid 1px ${props.$grey ? '#bfbfbe' : '#e9ece9'};
      padding-top: 16px;
      & + li {
        margin-top: 16px;
      }

      p {
        flex-grow: 1;
        display: flex;
        justify-content: space-between;
      }

      &:last-child {
        border-bottom: solid 1px ${props.$grey ? '#bfbfbe' : '#e9ece9'};
        padding-bottom: 16px;
      }
    }

    @media (min-width: ${props.theme.breakpoints.xl}) {
      padding-right: 32px;
      margin-top: 48px;
    }
  `}
`;

export const ProductApplications = ({ applications, grey = false }) => {
  return (
    <ProductSpecStyles $grey={grey}>
      <h3>Applications</h3>
      <ul>
        {applications.map((application) => {
          return <li key={application.name}>{application.name}</li>;
        })}
      </ul>
    </ProductSpecStyles>
  );
};
